import { render, staticRenderFns } from "./businessList.vue?vue&type=template&id=a52268fa&scoped=true&"
import script from "./businessList.vue?vue&type=script&lang=js&"
export * from "./businessList.vue?vue&type=script&lang=js&"
import style0 from "./businessList.vue?vue&type=style&index=0&id=a52268fa&lang=scss&scoped=true&"
import style1 from "./businessList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52268fa",
  null
  
)

export default component.exports